var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotification = function SvgIconNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.375 2a3.625 3.625 0 1 0 0 7.25 3.625 3.625 0 0 0 0-7.25M16.75 5.625a1.625 1.625 0 1 1 3.25 0 1.625 1.625 0 0 1-3.25 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5H4.75v13.75H18.5V12a1 1 0 1 1 2 0v7.5a1.75 1.75 0 0 1-1.75 1.75H4.5a1.75 1.75 0 0 1-1.75-1.75V5.25A1.75 1.75 0 0 1 4.5 3.5H12a1 1 0 1 1 0 2"
  }))));
};
export default SvgIconNotification;